"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeServiceImpl = void 0;
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ServiceImplBase_1 = require("./ServiceImplBase");
class SizeServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "size-service" /* ServiceNames.Size */;
    }
    changeSizeAsync(name, newSize) {
        var _a, _b, _c, _d;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'changeSizeAsync',
            [api_internal_contract_js_1.ParameterId.SheetName]: name,
            [api_internal_contract_js_1.ParameterId.MinHeight]: ((_a = newSize.minSize) === null || _a === void 0 ? void 0 : _a.height) || 0,
            [api_internal_contract_js_1.ParameterId.MinWidth]: ((_b = newSize.minSize) === null || _b === void 0 ? void 0 : _b.width) || 0,
            [api_internal_contract_js_1.ParameterId.MaxHeight]: ((_c = newSize.maxSize) === null || _c === void 0 ? void 0 : _c.height) || 0,
            [api_internal_contract_js_1.ParameterId.MaxWidth]: ((_d = newSize.maxSize) === null || _d === void 0 ? void 0 : _d.width) || 0,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SetSheetSize, parameters).then((_response) => {
            return;
        });
    }
}
exports.SizeServiceImpl = SizeServiceImpl;
//# sourceMappingURL=SizeServiceImpl.js.map